import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { Section } from '@hero/atoms';
import { PageLayout } from '@hero/layouts';
import { ThankYouNotes } from '@hero/organisms';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetThankYouNotes } from '@hero/services/order-service';

const RecognitionThankYouNoteDetail = () => {
  const { t } = useTranslation();
  const [params, setParams] = useState({});

  const { data: thankYouNotesById } = useGetThankYouNotes({
    type: 'recognition',
    ...params
  });

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <PageLayout
      header={{
        title: t('tyNotes'),
        backButton: {
          onClick: () => navigate(ROUTE_PATHS.MY_RECOGNITIONS)
        }
      }}
    >
      <Section>
        <ThankYouNotes
          defaultSelectedNote={thankYouNotesById.response.docs?.find?.(
            doc => doc.id === location.state.orderId
          )}
          thankYouNotesById={thankYouNotesById}
          getThankYouNotesById={params => {
            setParams(params);
          }}
        />
      </Section>
    </PageLayout>
  );
};

export { RecognitionThankYouNoteDetail };
